// Libraries
import { Flex, Text } from '@chakra-ui/react';
// Types
import { FormErrorProps } from './FormError.type';

/**
 * FormError component displays an error message within a styled container.
 *
 * @component
 * @param {FormErrorProps} props - The component props.
 * @param {string} props.children - The error message to be displayed.
 * @returns {ReactElement} - The FormError component.
 */
export const FormError = ({ children }: FormErrorProps) => {
  return (
    <Flex w='full' bg='error.20' borderRadius='base' px={1.5} data-testid='login-error-message'>
      <Text fontSize='s' lineHeight='base' color='text.error'>
        {children}
      </Text>
    </Flex>
  );
};
